<template>
  <PolicyLinksManager
    ref="managerRef"
    :resource-type="props.resourceType"
    :resource-id="props.resourceId"
    :company-id="props.companyId"
    @update:is-saving="emit('update:isSaving', $event)"
    @update:has-unsaved-changes="emit('update:hasUnsavedChanges', $event)"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import PolicyLinksManager from '@/components/designSystem/PolicyLinksManager/index.vue'
import type { AuthorizationResourcesAndSubjects } from '@/types/authorization'

const props = defineProps<{
  resourceType: AuthorizationResourcesAndSubjects
  resourceId: number
  companyId: number
}>()

const emit = defineEmits<{
  'update:isSaving': [value: boolean]
  'update:hasUnsavedChanges': [value: boolean]
}>()

const managerRef = ref<InstanceType<typeof PolicyLinksManager> | null>(null)

const handleSave = async () => {
  await managerRef.value?.handleSave()
}

defineExpose({ handleSave })
</script>
